// extracted by mini-css-extract-plugin
export default {"tabletBreakpoint":"990px","mobileBreakpoint":"660px"};